import React, {useState} from "react";
import QTextBox from "../../../../common/components/QTextBox";
import IntegrateApi from "../../../../common/api/functions/Integrate";
import {ResponseInterface} from "../../../../interfaces/ResponseInterface";
import {config} from "../../../../config";
import {Button, Col, Row} from "reactstrap";
import {Formik} from "formik";
import {QHelpers} from "../../../../common/helpers";
import {BusinessInterface} from "../../../../interfaces/private/BusinessInterface";
import BusinessApi from "../../../../common/api/functions/Business";
import {setToast} from "../../../../app/rootReducer";
import {useDispatch} from "react-redux";
import QButton from "../../../../common/components/QButton";
import {useTranslation} from "react-i18next";

interface Props {
    model: BusinessInterface,
    setOpen: Function,
    setLoadingFunc: Function,
    setBusiness: Function,
}

const BodyIntegrateComponent: React.FC<Props> = ({model, setOpen, setLoadingFunc,setBusiness}) => {
    const dispatch = useDispatch();
    const {t} = useTranslation();

    return (
        <React.Fragment>
            <Formik
                initialValues={{...model}}
                onSubmit={(values: any) => {
                    setLoadingFunc(true);
                    BusinessApi.update(values?.id, values).then(async (response: ResponseInterface | any) => {
                        if (response.status === config.STATUS_CODE.OK) {
                            await setOpen(false);
                            await setLoadingFunc(true);
                            await setBusiness(response?.data);
                            await setLoadingFunc(false);
                            await dispatch(setToast({
                                message: "Update success",
                                type: config.TOAST_TYPE.SUCCESS
                            }))
                        }
                    })
                }}
            >
                {formik => {
                    return (
                        <React.Fragment>
                            <Row>
                                <Col>
                                    <QTextBox
                                        label={t("business.detail.name")}
                                        value={formik.values.name}
                                        onChange={(value: string) => {
                                            formik.setFieldValue('name', value)
                                        }}
                                    />
                                    <QTextBox
                                        label={t("business.detail.cvrNo")}
                                        value={formik.values.cvr_no}
                                        onChange={(value: string) => {
                                            formik.setFieldValue('cvr_no', value)
                                        }}
                                    />
                                    <QTextBox
                                        label={t("business.detail.address")}
                                        value={formik.values.address}
                                        onChange={(value: string) => {
                                            formik.setFieldValue('address', value)
                                        }}
                                    />
                                    <QTextBox
                                        label={t("business.detail.zip")}
                                        value={formik.values.zip}
                                        onChange={(value: string) => {
                                            formik.setFieldValue('zip', value)
                                        }}
                                    />
                                    <QTextBox
                                        label={t("business.detail.city")}
                                        value={formik.values.city}
                                        onChange={(value: string) => {
                                            formik.setFieldValue('city', value)
                                        }}
                                    />
                                    <QTextBox
                                        label={t("business.detail.country")}
                                        value={formik.values.country}
                                        onChange={(value: string) => {
                                            formik.setFieldValue('country', value)
                                        }}
                                    />
                                    <QTextBox
                                        label={t("business.detail.email")}
                                        value={formik.values.email}
                                        onChange={(value: string) => {
                                            formik.setFieldValue('email', value)
                                        }}
                                    />
                                    <QTextBox
                                        label={t("business.detail.phone")}
                                        value={formik.values.phone}
                                        onChange={(value: string) => {
                                            formik.setFieldValue('phone', value)
                                        }}
                                    />
                                    <QTextBox
                                        label={t("business.detail.website")}
                                        value={formik.values.website}
                                        onChange={(value: string) => {
                                            formik.setFieldValue('website', value)
                                        }}
                                    />
                                </Col>
                            </Row>

                            <Row>
                                <Col>
                                    <div className={'d-flex justify-content-end gap-2'}>

                                        <QButton
                                            type={'default'}
                                            onClick={() => {  setOpen(0) }}
                                            content={t("common.button.cancel")}
                                        />

                                        <QButton
                                            type={'primary'}
                                            onClick={() => { formik.handleSubmit() }}
                                            content={t("common.button.submit")}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </React.Fragment>
                    )
                }}
            </Formik>
        </React.Fragment>
    )
}

export default BodyIntegrateComponent
